module.exports = __webpack_public_path__ + "img/f_4.7316abf.png";